// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"_2A0B-IsdRh3p","header":"SRNYgX18nx9U","body":"_1iUCXFrIpCyH","footer":"-MPGSLnD5qGh","promo_message":"_123FgRvji_Ur"};